<template>
  <ReplyItem class="comment-item" :reply="comment" :isComment="true" :aid="aid" @updateReplyList="updateReplyList">
    <Avatar class="comment-avatar" :src="comment.user.avatar" :size="isMobile ? 30 : 40" slot="prev" />
    <template slot="extra">
      <div class="reply-list" v-if="replyList && replyList.length" >
        <transition-group name="fade">
          <ReplyItem v-for="reply in replyList" :reply="reply" :aid="aid" :key="reply.reply_id" @updateReplyList="updateReplyList" />
        </transition-group>
        <div class="reply-more" v-if="!isEnd" @click="getReplyList">查看更多</div>
      </div>
    </template>
  </ReplyItem>
</template>

<script>
import {mapState} from 'vuex'

import gkButton from 'gkui/button'

import Avatar from '../../components/Avatar'
import CommentForm from './CommentForm'
import ReplyForm from './ReplyForm'
import ReplyItem from './ReplyItem'

import ArticleService from '../../service/article.service'

export default {
  name: 'comment-item',
  components: {
    gkButton,
    Avatar,
    CommentForm,
    ReplyForm,
    ReplyItem
  },
  props: {
    aid: {
      type: [String, Number],
      default: ''
    },
    comment: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      loading: false,
      score: Array.isArray(this.comment.reply_list.list) && this.comment.reply_list.list.length && this.comment.reply_list.list[this.comment.reply_list.list.length - 1].score || null,
      isEnd: !this.comment.reply_list.page.hasmore,
      replyList: this.comment.reply_list.list
    }
  },
  computed: {
    ...mapState(['isMobile', 'loginUser'])
  },
  mounted () {
  },
  methods: {
    /**
     * 获取回复列表
     */
    getReplyList () {
      if (this.isEnd || this.loading) {
        return
      }

      let postData = {
        id: this.comment.id,
        score: this.score
      }

      this.loading = true

      ArticleService.getReplyList(postData).then(res => {
        const {list} = res
        this.loading = false
        this.replyList = [...this.replyList, ...list]
        this.isEnd = !this.replyList.length || !list.length || !res.page.hasmore

        if (!this.isEnd) {
          this.score = list.length
                     ? list[list.length - 1].score
                     : this.replyList[this.replyList.length - 1].score
        }
      }).catch(() => {
        this.loading = false
      })
    },
    /**
     * 子组件回复成功后 更新当前组件的列表
     */
    updateReplyList (reply) {
      this.replyList = [reply, ...this.replyList]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/common';

.comment-item {
  position: relative;
  padding: 16px 0 16px 52px;
  border-top: 1px solid $borderGray;

  & .comment-avatar {
    position: absolute; left: 0; top: 14px;
  }
}

.reply-list {
  position: relative;
  box-sizing: border-box;
  padding: 15px 0 15px 15px; margin-top: 16px;
  border-top: 1px solid #F0F1F3;

  &:before {
    content: ' ';
    position: absolute; top: 15px; left: 0; bottom: 15px;
    width: 4px;
    background: #F0F1F3;
    border-radius: 2px;
  }

  & ::v-deep .reply-item:last-child {
    padding-bottom: 0;
  }

  & .reply-more {
    position: relative; top: 10px;
    width: 60px;
    margin: 0 auto;
    text-align: center;
    @include lineFont(12, 400);
    color: $gray;
    cursor: pointer;
    user-select: none;
  }
}

@media screen and (max-width: 768px) {
  .comment-item {
    padding: 14px 0 14px 38px;
    border-top: none;

    & .comment-avatar {
      top: 14px;
    }
  }


  .reply-list {
    padding: 10px 0 10px 12px; margin-top: 8px;
    border-radius: 0px; 
    border: none;

    &:before {
      top: 10px; bottom: 10px;
      width: 2px;
    }

    // &:before,
    // &:after {
    //   display: none;
    // }

    & .reply-more {
      top: 0;
      margin-top: 8px;
    }
  }
}
</style>

 